import React from 'react';
const MarginCalculatorContext = React.createContext();
export default MarginCalculatorContext;
